import React from 'react';
import PropTypes from 'prop-types';

export default class UploadDropzone extends React.Component
{
    state = {
        files: []
    };

    static propTypes = {
        multiple: PropTypes.bool,
        uploadFile: PropTypes.func.isRequired,
    };

    static defaultProps = {
        multiple: false,
    };

    constructor(props)
    {
        super(props);

        this.input = React.createRef();
    }

    render()
    {
        return <>
            <div onDrop={this.onDrop} onDragOver={e => e.preventDefault()} className={this.props.className}>
                <div
                    className="flex w-full h-full justify-center items-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                    <div className="text-center">
                        <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none"
                             viewBox="0 0 48 48">
                            <path
                                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <p className="mt-1 text-sm text-gray-600">
                            <button className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition duration-150 ease-in-out" onClick={() => this.input.current.click()}>
                                Upload a file
                            </button> or drag and drop
                        </p>
                        <p className="mt-1 text-xs text-gray-500">
                            PNG, JPG, GIF up to 10MB
                        </p>
                    </div>
                </div>
            </div>

            <input value="" ref={this.input} className="hidden" type="file" multiple={this.props.multiple} accept=".png,.gif,.jpg,.jpeg,image/png,image/jpg,image/jpeg,image/gif" onChange={this.onFilesAdded} />
        </>;
    }

    // ---

    onFilesAdded = e => {
        this.addFiles(e.target.files)
    };

    onDrop = event => {
        event.preventDefault();

        this.addFiles(event.dataTransfer.files)
    };

    addFiles = fileList => {
        const files = fileListToArray(fileList);

        files.forEach(file => {
            this.props.uploadFile(file);
        });
    };
}

const fileListToArray = list => {
    const array = [];

    for (let i = 0; i < list.length; i++) {
        array.push(list.item(i));
    }

    return array;
};